<template>
  <v-main>
    <v-container fill-height fluid class="forbidden">
      <v-card
        class="mx-auto"
        max-width="700"
        max-height="720"
        color="#6ab7cf"
      >
        <v-list-item class="addColor">
            <v-list-item-content>
                <v-list-item-title
                    class="text-h1 mb-1 pink--text font-weight-bold"
                >401</v-list-item-title>
                <v-list-item-title class="title mb-1 text-wrap">
                    <!-- eslint-disable-next-line max-len -->
                    <p>You don't have permission to access this resource.<br/><br/>You may need to login again.<br/><br/>If this doesn't help please submit a support ticket.</p>
                </v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar
                tile
                aspect-ratio="2/3"
                size="300"
                class="image"
            >
                <v-img src="@/assets/pexels-photo-7479746.jpeg"></v-img>
            </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            @click="validate"
          >{{ LoginorLogoutText }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'AccessDenied',
  data: () => ({
    temp: null,
  }),
  computed: {
    validated() {
      return this.$store.state.validated;
    },
    LoginorLogoutText() {
      if (this.validated) {
        return 'Logout';
      }

      return 'Login';
    },
  },
  methods: {
    validate() {
      if (this.validated) {
        this.$store.dispatch('logout');
      } else {
        this.$store.dispatch('validateUser');
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
